export default {
	name: 'OAuthCallback',
	path: '/oauth-callback',
	meta: {
		title: 'OAuth 回调'
	}
};

